import { render, staticRenderFns } from "./VideoDetailsModule.vue?vue&type=template&id=52957842&scoped=true"
import script from "./VideoDetailsModule.vue?vue&type=script&lang=js"
export * from "./VideoDetailsModule.vue?vue&type=script&lang=js"
import style0 from "./VideoDetailsModule.vue?vue&type=style&index=0&id=52957842&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52957842",
  null
  
)

export default component.exports